/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections(cart) {
  this.constructors = {};
  this.instances = [];
  this.cart = cart;

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');
    constructor = constructor || this.constructors[type];
    options = {}
    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
      cart: this.cart
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function'){
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if(typeof instance !== 'undefined' && typeof instance.onDeselect === 'function'){
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt){
    var instance = this.instances.find(function(instance){
      return instance.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function'){
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt){
    var instance = this.instances.find(function(instance){
      return instance.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function'){
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function(container){
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  keyboardKeys: {TAB: 9,ENTER: 13,ESCAPE: 27,LEFTARROW: 37,RIGHTARROW: 39}
};

window.slate = window.slate || {};


theme.Cart = (function() {
  function Cart(options){
    console.log('cart init');
    this.selectors = {
      addToCart: '[data-add-to-cart]',
      shopifyPaymentButton: '.shopify-payment-button',
      cartPopup: '[data-mini-cart-body]',
      cartPopupItems: '[data-cart-items]',
      cartPopupTotal: '[data-cart-total]',
      cartPopupLoyalty: '[data-lion-points-for]',
      cartPopupFreebar: '.cart-mini__intro .freebar-heading',
      cartPopupNum: '[data-cart-num]',
      cartPopupIcon: '[data-cart-icon]',
      cartPopupTotalWrapper: '[data-cart-total-wrapper]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]'
    };
    this.classes = {
      hidden: 'hide',
      inputError: 'input--error',
    };

    this.cartPopup = this.cartPopup || document.querySelector(this.selectors.cartPopup);
    this.cartPopupTotal = this.cartPopupTotal || document.querySelector(this.selectors.cartPopupTotal);
    this.cartPopupTotalWrapper = this.cartPopupTotalWrapper || document.querySelector(this.selectors.cartPopupTotalWrapper);
    this.cartPopupLoyalty = this.cartPopupLoyalty || document.querySelector(this.selectors.cartPopupLoyalty);
    this.cartPopupFreebar = this.cartPopupFreebar || document.querySelector(this.selectors.cartPopupFreebar);
    this.cartPopupNum = this.cartPopupNum || document.querySelectorAll(this.selectors.cartPopupNum);
    this.cartPopupIcon = this.cartPopupIcon || document.querySelectorAll(this.selectors.cartPopupIcon);
    this.cartPopupItems = this.cartPopupItems || document.querySelector(this.selectors.cartPopupItems);
    if(this.cartPopup){
      this.cartPopup.addEventListener('click', this._onRemoveItem.bind(this),false);
      this.cartPopup.addEventListener('change', this._onQtyChange.bind(this),false);
    }
    this.errorMessageWrapper = document.querySelector(this.selectors.errorMessageWrapper);
    this.addToCart = document.querySelectorAll(this.selectors.addToCart);
    this.shopifyPaymentButton = document.querySelector(this.selectors.shopifyPaymentButton);
    // init Addtocart features on recommendations
    /*document.addEventListener('click', (event) => {
      if (event.target.classList.contains("button-add")){
        var add = this._addItemToCart(event.target,false);
        if(add !== true) cart-mini__error
      }
    })*/
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {

    _onRemoveItem: function(e){
      var _self = this;
      if (e.target.closest('[data-cart-remove]')) {
        var itemEl = e.target.closest('.cart-item');
        var index = parseInt(itemEl.getAttribute('data-cart-item-index'));

        var request ={
          method:'POST', headers: {'Content-Type': 'application/json;'},
          body: JSON.stringify({ line: index, quantity: 0 })
        };

        fetch('/cart/change.js', request).then(function(response) {
          return response.json();
        })
        .then(
          function(json) {
            if (json.status && json.status !== 200) {
              var error = new Error(json.description);
              error.isFromServer = true;
              throw error;
            }
              let cartItemRemoved = new CustomEvent('cartItemRemoved', {
              detail: json  // Optional data
            });
            document.dispatchEvent(cartItemRemoved);
            if (json.item_count === 0) {
              _self.emptyCart();
            } else {
              _self._setCartContent(json);
            }
            console.log('removed');
            _self.hideCartError();
          }
        )
        .catch(
          function(error){
            _self.showCartError(error.isFromServer&&error.message.length ? error.message : theme.strings.cartError);
            console.log(error);
            _self._clearCart();
          }
        );
      }
    },
    _clearCart: function(){
      var _self = this;
      var request = {
        method:'POST', headers: {'Content-Type': 'application/json;'}
      };
      fetch('/cart/clear.js', request).then(function(response) { return response.json() })
        .then(function(json) {
            if (json.item_count === 0){
               _self.emptyCart();
               _self.hideCartError();
            }
          }
        )
        .catch( function(error){ console.log(error) });
    },
    _onQtyChange: function(e){
      if (e.target.closest('[data-quantity-input]')) {
        var _self = this;
        console.log('_onQtyChange');
        var itemEl = e.target.closest('.cart-item');
        var index = parseInt(itemEl.getAttribute('data-cart-item-index'));
        var qty = e.target.closest('[data-quantity-input]').value;

        var request ={
          method:'POST', headers:{'Content-Type': 'application/json;'},
          body: JSON.stringify({ line: index, quantity: qty })
        };

        fetch('/cart/change.js', request).then(function(response) {
          return response.json();
        })
        .then(
          function(json) {
            if (json.status && json.status !== 200) {
              var error = new Error(json.description);
              error.isFromServer = true;
              throw error;
            }
            if (json.item_count === 0){
              _self.emptyCart();
            }else{
              _self._setCartContent(json);
            }
            console.log('updated qty');
            _self.hideCartError();
          }
        )
        .catch(
          function(error) {
            _self.showCartError(error.isFromServer && error.message.length? error.message : theme.strings.cartError);
            console.log(error);
          }
        );
      }
    },
    emptyCart: function(){
      console.log('_emptyCart');
      this.cartPopupItems.innerHTML = '<div class="heading-5">'+theme.strings.cartEmpty+'</div>';
      this.cartPopupTotalWrapper.classList.add(this.classes.hidden);
      this.cartPopupLoyalty.setAttribute('data-lion-points-for',0);
      if(this.cartPopupFreebar) this.cartPopupFreebar.classList.add(this.classes.hidden);
      window.loyaltylion && window.loyaltylion.ui.refresh();

      this.cartPopupNum.forEach(function(el) {el.innerText = ""});
      this.cartPopupIcon.forEach(function(el) {
        el.classList.remove('icon-card-fill'); el.classList.add('icon-card');
      });
    },
    hideCartError: function() {
      document.querySelector('.cart-mini__error').textContent = "";
      document.querySelector('.cart-mini__error').classList.add(this.classes.hidden);
    },
    showCartError: function(msg) {
      document.querySelector('.cart-mini__error').textContent = msg;
      document.querySelector('.cart-mini__error').classList.remove(this.classes.hidden);
    },
    updateCartPopupContent: function() {
      var self = this;
      console.log('_updateCartPopupContent');
      fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        self._setCartContent(cart);
        document.querySelector('[data-mini-cart-open]').click();
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    _setCartContent: function(cart) {
      var self = this;
      this.cartPopupItems.innerHTML = "";
      var idx = 1, sumForLoyalty = 0,param;
      cart.items.forEach(function(item,i) {
        //exclude gift wraps
        if(item.image&&item.variant_id!=40562210078802&&item.variant_id!=40562212569170) self._addCartItem(item,i+1);
        param = item.properties;
        if(!param || !param._sale) sumForLoyalty+=item.final_line_price;
      });
      this.cartPopupTotal.innerText = theme.Currency.formatMoney(
        cart.total_price,
        theme.moneyFormat
      );
      this.cartPopupNum.forEach(function(el) {el.innerText = cart.item_count});
      this.cartPopupIcon.forEach(function(el) {
        el.classList.remove(cart.item_count>0?'icon-card':'icon-card-fill');
        el.classList.add(cart.item_count>0?'icon-card-fill':'icon-card');
      });
      this.cartPopupTotalWrapper.classList.remove(this.classes.hidden);
      if(this.cartPopupFreebar){
        if(cart.total_price < 20000){
          this.cartPopupFreebar.classList.remove(this.classes.hidden);
          var cartPopupFreebarSpan = this.cartPopupFreebar.querySelector('span');
          cartPopupFreebarSpan.innerText = theme.Currency.formatMoney(20000 - cart.total_price, theme.moneyFormat);
        }
        else{
          this.cartPopupFreebar.classList.add(this.classes.hidden);
        }
      }
      if(this.cartPopupLoyalty){
        if(sumForLoyalty>0)
          this.cartPopupLoyalty.setAttribute('data-lion-points-for',sumForLoyalty);
        else this.cartPopupLoyalty.setAttribute('data-lion-points-for',0);
        if(window.loyaltylion && window.loyaltylion.ui) window.loyaltylion && window.loyaltylion.ui.refresh();
      }
    },

    _addCartItem: function(item,idx) {
      var newItem = '<div class="cart-item cart-item--large" data-cart-item-index="'+idx+'">';
      var newItemImg = item.image?item.image:"", i = newItemImg.lastIndexOf('.');
      if (i != -1) {
        newItemImg = newItemImg.substr(0, i) + "_x250" + newItemImg.substr(i);
      }
      var img = '<div class="cart-item__image"><div class="double-image-hover"><picture><img src="' + newItemImg + '" alt="'+item.product_title+'"></picture></div></div>';
      var price = theme.Currency.formatMoney(item.final_price,	theme.moneyFormat);
      newItem += img;
      newItem += '<div class="cart-item__content">';
      newItem += '<div class="cart-item__heading"><a href="'+item.url+'" rel="nofollow">'+item.product_title+'</a></div>';
      newItem += '<div class="cart-item__row"><strong>'+price+'</strong></div>';
      if(item.options_with_values){
        newItem += '<div class="cart-item__row">';
        item.options_with_values.forEach(function(option) {
          if(option.value != 'Default Title') newItem += '<div class="cart-item-prop"><div class="cart-item-prop__key">' + option.name + ':</div><div class="cart-item-prop__value">' + option.value + '</div></div>';
        });
        newItem += '</div>';
      }
      newItem += '<div class="cart-item__row"><div class="quantity"><button data-offset="-1">-</button><input type="number" value="' + item.quantity + '" data-quantity-input><button data-offset="1">+</button></div><button class="button button-fade button-small" data-cart-remove>REMOVE</button></div>';
      newItem += '</div>';
      newItem += '</div>';
      this.cartPopupItems.insertAdjacentHTML('beforeend', newItem);
    },
    _addItemToCart: function(form,formtrue) {
      this._handleButtonLoadingState(true);
      var self = this;
      fetch('/cart/add.js',{
        method:'POST',credentials:'same-origin',
        headers: {
          'Content-Type':formtrue ? 'application/x-www-form-urlencoded' : 'application/json',
          'X-Requested-With':'XMLHttpRequest'
        },
        body: formtrue ? theme.Helpers.serialize(form) : JSON.stringify({items:[{"quantity":1, "id":form.dataset.id}]})
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        /*rfk.push(["trackEvent", {
          "type": "a2c",
          "name": "pdp",
          "quantity": 1,
          "value":{ "products": [{ "quantity": form.querySelector('[data-quantity-input]').value, "price": form.querySelector('[data-regular-price]').innerText.replace('$',''), "sku": formtrue ? form.querySelector('[data-id]').dataset.id : form.dataset.id }] }
        }]);*/
        self.updateCartPopupContent();
        if(formtrue) self._hideErrorMessage(); else self.hideCartError();
        self._handleButtonLoadingState(false);
        return true;
      })
      .catch(function(error) {
        //self.previouslyFocusedElement.focus();
        var msg = error.isFromServer && error.message.length ? error.message : theme.strings.cartError;
        console.log(msg);
        if(formtrue) self._showErrorMessage(msg); else self.showCartError(msg);
        self._handleButtonLoadingState(false);
        return error;
      });
    },
    // add loader and disabled state to button
    _handleButtonLoadingState: function(isLoading) {
      var classHid = this.classes.hidden;
      if (isLoading) {
        this.addToCart.forEach(function(el) {
          el.setAttribute('aria-disabled', true);
          el.setAttribute('disabled', true)
        });

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.setAttribute('disabled', true);
        }

      } else {
        this.addToCart.forEach(function(el) {
          el.removeAttribute('aria-disabled');
          el.removeAttribute('disabled');
        });

        /*this.loader.forEach(function(el) {
          el.classList.add(classHid);
        });*/

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.removeAttribute('disabled');
        }
      }
    },
    _showErrorMessage: function(errorMessage) {
      var errorMessageContainer = this.errorMessageWrapper.querySelector(this.selectors.errorMessage);
      if(errorMessageContainer){
        errorMessageContainer.innerHTML = errorMessage;
        this.errorMessageWrapper.classList.remove( this.classes.hidden );
        this.errorMessageWrapper.setAttribute('aria-hidden', true);
        this.errorMessageWrapper.removeAttribute('aria-hidden');
      }
    },
    _hideErrorMessage: function() {
      this.errorMessageWrapper.classList.add(this.classes.hidden);
    }
  });
  return Cart;
})();

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function(element) {
    if (!element) return;
    var focusClass = 'js-focus-hidden';

    element.setAttribute('tabIndex', '-1');
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener('blur', callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute('tabindex');
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function(options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function(element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue('display') !== 'none'
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener('focusin', this._onFocusInHandler);
    document.addEventListener('focusout', this._onFocusOutHandler);
  },

  _setupHandlers: function() {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function() {
    document.removeEventListener('keydown', this._manageFocusHandler);
  },

  _onFocusIn: function(evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener('keydown', this._manageFocusHandler);
  },

  _manageFocus: function(evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function(options) {
    if (options.container) {
      options.container.removeAttribute('tabindex');
    }
    document.removeEventListener('focusin', this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        'a[href]:not([aria-describedby])'
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function(link) {
      var target = link.getAttribute('target');
      var rel = link.getAttribute('rel');
      var isExternal = _externalSite(link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        link.setAttribute('aria-describedby', idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf('noopener') === -1) {
          var relValue = rel === undefined ? '' : rel + ' ';
          relValue = relValue + 'noopener';
          link.setAttribute('rel', relValue);
        }

        link.setAttribute('aria-describedby', idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.	Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.container = options.container;
    this.product = options.product;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.singleOptions = this.container.querySelectorAll(options.singleOptionSelector);
    this.currentVariant = this._getVariantFromOptions();
    this._initOptions();
    console.log('init Variants');
    //this._onSelectChange();
    this.singleOptions.forEach(
      function(option){
        if(option.dataset.type != "color") option.addEventListener('click', this._onSelectChange.bind(this))
      }.bind(this)
    );
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {

    // init options
    _initOptions: function() {
      console.log('_initOptions');
      if(this.singleOptions){
        var selectedValues = this._getCurrentOptions();
        this.singleOptions.forEach(
          function(option) {
            if(option.dataset.type !="color"){
              selectedValues.find(function(opt,i){
                if (option.dataset.index === opt.index) {
                  selectedValues[i] = { value: option.getAttribute('data-label'), index: option.getAttribute('data-index') };
                  return true; // stop searching
                }
              })
              var found = this.product.variants.find(function(variant) {
                return selectedValues.every(function(values) {
                  return variant[values.index] === values.value;
                });
              });
              if(found.available) option.setAttribute('data-disabled','false')
              else option.setAttribute('data-disabled','true');
            }
            else {
              option.setAttribute('data-disabled','false');
              option.addEventListener('click', function(){window.location = this.href});
            }//turn on colors
          }.bind(this)
        );
      }
    },
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var result = [];

      this.singleOptions.forEach(function(option) {
        var type = option.getAttribute('type');
        var isChecked = option.classList.contains("is-active");

        if (isChecked) {
          result.push({
            value: option.getAttribute('data-label'),
            index: option.getAttribute('data-index')
          });
        }
      });

      return result;
    },

    /**
     * Find variant based on selected values.
     *
     * @param	{array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] === values.value;
        });
      });
      //console.log(found);
      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      console.log('_onSelectChange');
      this.container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updatePrice(variant);
      this._updateFavorites(variant);
      //this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },
    _updateFavorites: function(variant){
      document.querySelector('.product-favorite').setAttribute('data-varid',variant.id);
      document.querySelector('.product-favorite').setAttribute('data-vart',variant.public_title);
    },
    /**
     * Trigger event when variant price changes.
     *
     * @param	{object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price &&
        variant.unit_price === this.currentVariant.unit_price){
        //console.log("no changes");
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantPriceChange', {
          detail: { variant: variant },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param	{object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    /*_updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },*/

    /**
     * Update history state for product deeplinking
     *
     * @param	{variant} variant - Currently selected variant
     * @return {k} 				[description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },
    /**
     * Update hidden master select of variant change
     *
     * @param	{variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      var masterSelect = this.container.querySelector(this.originalSelectorId);

      if (!masterSelect) return;
      masterSelect.value = variant.id;
    }
  });

  return Variants;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};


theme.Helpers = (function() {
  var touchDevice = false;

  var classes = {
    preventScrolling: 'prevent-scrolling'
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this,
        args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      var prior = beforeEl || document.getElementsByTagName('script')[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      'transitionend',
      function(event) {
        event.currentTarget.classList.remove('is-transitioning');
      },
      { once: true }
    );

    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration'
    ];

    var duration = 0;

    properties.forEach(function(property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, '');
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param	{Node} 	form The form to serialize
   * @return {String}			The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === 'undefined') {
      this.stylesheetPromise = new Promise(function(resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener('load', function() {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet
  };
})();

/* ================ TEMPLATES ================ */

window.theme = theme || {};

theme.Product = (function() {
  function Product(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.ajaxEnabled = true;
    console.log('init Product');

    this.settings = {
      bpSmall: false,
      enableHistoryState: container.getAttribute('data-enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      cartPopup: '[data-mini-cart-body]',
      cartPopupItems: '[data-cart-items]',
      cartPopupTotal: '[data-cart-total]',
      cartPopupTotalWrapper: '[data-cart-total-wrapper]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',

      //loader: '[data-loader]',
      quantity: '[data-quantity-input]',
      quantityBlock: '[data-type="quantity"]',
      SKU: '.variant-sku',
      //productStatus: '[data-product-status]',
      //productStatusText: '[data-product-status-text]',
      //productStatusState: '[data-product-status-state]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      consoleFeatures: '#product-features',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      productMediaWrapper: '.product-view-image',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '[data-option]',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      msrpPrice: '[data-msrp-price]',
      salePrice: '[data-sale-price]',
      productPolicies: '[data-product-policies]'
    };

    this.classes = {
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      activeClass: 'active-thumb'
    };

    this.eventHandlers = {};

    this.errorMessageWrapper = container.querySelector(this.selectors.errorMessageWrapper);
    this.productForm = container.querySelector(this.selectors.productForm);
    this.priceContainer = container.querySelectorAll(this.selectors.priceContainer);
    //this.productStatus = container.querySelector(this.selectors.productStatus);
    //this.productStatusText = this.productStatus.querySelector(this.selectors.productStatusText);
    //this.productStatusState = this.productStatus.querySelector(this.selectors.productStatusState);
    this.productPolicies = container.querySelector(this.selectors.productPolicies);
    this.addToCart = container.querySelectorAll(this.selectors.addToCart);

    /*this.storeAvailabilityContainer = container.querySelector(this.selectors.storeAvailabilityContainer);
    if (this.storeAvailabilityContainer) {	this._initStoreAvailability();	}*/

    //this.loader = container.querySelectorAll(this.selectors.loader);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    var productJson = document.getElementById('ProductJson-' + sectionId);
    if (!productJson || !productJson.innerHTML.length) {
      return;
    }

    this.productSingleObject = JSON.parse(productJson.innerHTML);

    // Initial state for global productState object
    this.productState = {
      available: true,
      soldOut: false,
      onSale: false//,
      //showUnitPrice: false
    };
    this._stringOverrides();
    this._initProductHandlers();
    this._initVariants();
    //this._initOptions();
    //this._initCartPopup();
    this._initAddToCart();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      theme.strings = Object.assign({}, theme.strings, theme.productStrings);
    },
    _initVariants: function() {
      var options = {
        container: this.container,
        enableHistoryState: this.container.getAttribute('data-enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);
      if (this.storeAvailability && this.variants.currentVariant.available) {
        this.storeAvailability.updateContent(this.variants.currentVariant.id);
      }

      this.eventHandlers.updateAvailability = this._updateAvailability.bind(this);
      //this.eventHandlers.updateMedia = this._updateMedia.bind(this);
      this.eventHandlers.updatePrice = this._updatePrice.bind(this);
      //this.eventHandlers.updateSKU = this._updateSKU.bind(this);

      this.container.addEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      /*this.container.addEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );*/
      this.container.addEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      /*this.container.addEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );*/
    },
    _initProductHandlers: function(){
      //console.log('_initProductHandlers');
      var self = this;
    },

    // init Addtocart features on form submit
    _initAddToCart: function(){
      this.productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        /*var fl = false;
        this.addToCart.forEach(function(el) {
          if (el.getAttribute('aria-disabled') === 'true') {
            fl = true;
          }
        });
        if (fl) return;
        if (!this.ajaxEnabled) return;

        this.previouslyFocusedElement = document.activeElement;*/
        if(this.productForm.classList.contains("waitlist")!=false){
          var _klOnsite = window._klOnsite || [];
          _klOnsite.push(['openForm', 'YzPe22']);/* klaviyo */
          setTimeout(function(){
            var form = document.querySelector('[data-testid="klaviyo-form-YzPe22"]');
            if(form){
              /*var inputDivField = form.querySelector('[data-testid="form-row"]:nth-child(2) > div:first-child'), inputField;
              if(inputDivField){
                inputField = inputDivField.querySelector('input')
                inputDivField.classList.add('hide');
                inputField.value = document.querySelector('h1.product__heading').innerText;
              }*/
            }
          },400)
          return;
        }
        var isInvalidQuantity = !!this.quantityInput && this.quantityInput.value <= 0;

        if (isInvalidQuantity){
          this._showErrorMessage(theme.strings.quantityMinimumMessage);
          return;
        }

        if (!isInvalidQuantity && this.ajaxEnabled){
          this.cart._addItemToCart(this.productForm,true);
          return;
        }
        var _learnq = _learnq || [];
        _learnq.push(['track', 'Added to Cart', item]);
      }.bind(this) );
    },

    _showErrorMessage: function(errorMessage) {
      var errorMessageContainer = this.errorMessageWrapper.querySelector(this.selectors.errorMessage);
      if(errorMessageContainer){
        errorMessageContainer.innerHTML = errorMessage;
        this.errorMessageWrapper.classList.remove( this.classes.hidden );
        this.errorMessageWrapper.setAttribute('aria-hidden', true);
        this.errorMessageWrapper.removeAttribute('aria-hidden');
      }
    },

    _hideErrorMessage: function() {
      this.errorMessageWrapper.classList.add(this.classes.hidden);
    },

    _enableAddToCart: function(message) {
      this.addToCart.forEach(function(el) {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('disabled');
        if(el.dataset.alt){
          message = el.dataset.alt;
        }
        el.setAttribute('aria-label', message);
        el.innerHTML = message;
      });
      var qtyBlock = this.container.querySelector(this.selectors.quantityBlock);
      qtyBlock.classList.remove('hide');
      //this.productStatusText.innerHTML = theme.strings.inStock;
      //this.productStatusState.classList.add('icon-check');
      //this.productStatusState.classList.remove('icon-close');
    },

    _disableAddToCart: function(message) {
      console.log('disable cart');
      message = message || theme.strings.unavailable;
      this.addToCart.forEach(function(el) {
        el.setAttribute('aria-disabled', true);
        el.setAttribute('disabled',true);
        el.setAttribute('aria-label', message);
        el.innerHTML = message;
      });
      var qtyBlock = this.container.querySelector(this.selectors.quantityBlock);
      qtyBlock.classList.add('hide');
      //this.productStatusText.innerHTML = theme.strings.outOfStock;
      //this.productStatusState.classList.add('icon-close');
      //this.productStatusState.classList.remove('icon-check');
    },
    _preorderAddToCart: function() {
      console.log('preorder cart');
      message = 'Preorder Now';
      this.addToCart.forEach(function(el) {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('disabled');
        el.setAttribute('aria-label', message);
        el.innerHTML = message;
      });
      var qtyBlock = this.container.querySelector(this.selectors.quantityBlock);
      qtyBlock.classList.remove('hide');
    },

    _updateAddToCart: function() {
      if (!this.productState.available) {
        this._disableAddToCart(theme.strings.unavailable);
        return;
      }
      if (this.productState.soldOut) {
        this._disableAddToCart(theme.strings.soldOut);
        return;
      }
      if(this.productState.preorder){
        this._preorderAddToCart();
        return;
      }
      this._enableAddToCart(theme.strings.addToCart);
    },
    /**
     * The returned productState object keeps track of a number of properties about the current variant and product
     * Multiple functions within product.js leverage the productState object to determine how to update the page's UI
     * @param {object} evt - object returned from variant change event
     * @return {object} productState - current product variant's state
     *									productState.available - true if current product options result in valid variant
     *									productState.soldOut - true if variant is sold out
     *									productState.onSale - true if variant is on sale
     *									productState.showUnitPrice - true if variant has unit price value
     */
    _setProductState: function(evt) {
      var variant = evt.detail.variant;
      var cons = evt.detail.cons;

      if (!variant ) {
        this.productState.available = false;
        return;
      }
      this.productState.available = true;
      this.productState.soldOut = !variant.available || (cons && cons.a == false);
      this.productState.onSale = variant.compare_at_price > variant.price;
      this.productState.preorder = false;

      var preOrders = document.querySelectorAll('div[data-preorder-sku]');
      var preOrder = false; var but;
      var buts = document.querySelectorAll('input[data-preorder-sku]');
      buts.forEach(function(b) {
        b.setAttribute('disabled',true);
      });
      preOrders.forEach(function(pre) {
        but = document.querySelector('input[data-preorder-sku="'+variant.sku+'"]');
        if(variant.sku == pre.dataset.preorderSku){
          pre.classList.remove('hide');
          but.removeAttribute('disabled');
          preOrder = true;
        }
        else {
          pre.classList.add('hide');
        }
      });
      if(preOrder) this.productState.preorder = true;
      //data-preorder-sku
      //this.productState.showUnitPrice = !!variant.unit_price;
    },
    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();
      // set product state
      this._setProductState(evt);
      // update store availabilities info
      this._updateStoreAvailabilityContent(evt);
      // update form submit
      this._updateAddToCart();
      this._updatePriceComponentStyles(evt);
    },

    _updateStoreAvailabilityContent: function(evt) {
      if (!this.storeAvailability) {
        return;
      }

      if (this.productState.available && !this.productState.soldOut) {
        this.storeAvailability.updateContent(evt.detail.variant.id);
      } else {
        this.storeAvailability.clearContent();
      }
    },

    /*_updateMedia: function(evt) {
      var variant = evt.detail.variant;
      this._switchMedia(variant.title);
    },*/

    _hidePriceComponent: function() {

      this.priceContainer.forEach(function(priceContainer) {
        priceContainer.classList.add(this.classes.productUnavailable);
        priceContainer.setAttribute('aria-hidden', true);
      });
      if (this.productPolicies) {
        this.productPolicies.classList.add(this.classes.visibilityHidden);
      }
    },

    _updatePriceComponentStyles: function(evt) {
      var variant = evt.detail.variant;

      /*var unitPriceBaseUnit = this.priceContainer.querySelector(
        this.selectors.unitPriceBaseUnit
      );*/

      if (!this.productState.available) {
        this._hidePriceComponent();
        return;
      }

      if (this.productState.soldOut) {
        this.priceContainer.forEach(function(priceContainer) {
          priceContainer.classList.add(this.classes.productSoldOut);
        }.bind(this));
      } else {
        this.priceContainer.forEach(function(priceContainer) {
          priceContainer.classList.remove(this.classes.productSoldOut);
        }.bind(this));
      }

      /*if (this.productState.showUnitPrice) {
        unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
        this.priceContainer.classList.add(this.classes.productUnitAvailable);
      } else {
        this.priceContainer.classList.remove(this.classes.productUnitAvailable);
      }*/

      /*if (this.productState.onSale) {
        this.priceContainer.classList.add(this.classes.productOnSale);
      } else {
        this.priceContainer.classList.remove(this.classes.productOnSale);
      }*/

      this.priceContainer.forEach(function(priceContainer) {
        priceContainer.classList.remove(this.classes.productUnavailable);
        priceContainer.removeAttribute('aria-hidden');
      }.bind(this));
      if (this.productPolicies) {
        this.productPolicies.classList.remove(this.classes.visibilityHidden);
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.detail.variant;
      console.log("_updatePrice");
      var regularPrices = this.container.querySelectorAll(this.selectors.regularPrice);
      var msrpPrices = this.container.querySelectorAll(this.selectors.msrpPrice);

      var formatRegularPrice = function(regularPriceElement, price) {
        regularPriceElement.innerHTML = (price > 0) ? theme.Currency.formatMoney(
          price,
          theme.moneyFormat
        ) : "";
      };

      msrpPrices.forEach(function(regularPrice) {
        formatRegularPrice(regularPrice, variant.compare_at_price);
      });
      regularPrices.forEach(function(regularPrice) {
        formatRegularPrice(regularPrice, variant.price);
      });
      // On sale
      /*if (this.productState.onSale) {
        regularPrices.forEach(function(regularPrice) {
          formatRegularPrice(regularPrice, variant.compare_at_price);
        });
        salePrice.innerHTML = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      } else {
        // Regular price
        regularPrices.forEach(function(regularPrice) {
          formatRegularPrice(regularPrice, variant.price);
        });
      }*/

      // Unit price
      /*if (this.productState.showUnitPrice) {
        unitPrice.innerHTML = theme.Currency.formatMoney(
          variant.unit_price,
          theme.moneyFormat
        );
      }*/
    },

    /*_updateSKU: function(evt) {
      var variant = evt.detail.variant;

      // Update the sku
      var sku = document.querySelector(this.selectors.SKU);
      if (!sku) return;
      sku.innerHTML = variant.sku;
    },*/

    onUnload: function() {
      this.container.removeEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      /*this.container.removeEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );*/
      this.container.removeEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      /*this.container.removeEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );*/
    }
  });

  return Product;
})();


document.addEventListener('DOMContentLoaded', function() {
  var cart = new theme.Cart();
  var sections = new theme.Sections(cart);
  //sections.register('header-section', theme.HeaderSection);
  sections.register('product', theme.Product);
  /* redirect from registration page to account */
  var captcha = document.getElementById('g-recaptcha'),
  form = document.querySelector('.shopify-challenge__container form');

  if(captcha && form){
  var b = document.querySelector('.shopify-challenge__button');
  b.classList.add('button');
  b.classList.add('button-primary');
    var formSrc = form.getAttribute('action');
    if(formSrc.indexOf("account") !== -1 && sessionStorage.getItem('lasturl').indexOf("register") === -1){
      var returnTo = document.createElement("div");
      returnTo.innerHTML = '<input type="hidden" name="return_to" value="/account" />';
      form.insertBefore(returnTo,captcha);
    }
  }
  sessionStorage.setItem('lasturl', window.location.href);
});
